<template>
    <section class="mx-2 my-4" :aria-labelledby="goalTitleId">
        <BaseCard theme="cream" radius="lgr" padding="sm" class="flex w-full min-w-0 max-w-[600px] items-start gap-3 md:w-full">
            <span class="icon" aria-hidden="true"><DevelopmentGoalHourglass class="size-5" /></span>
            <div class="flex min-w-0 grow flex-col gap-1">
                <h2 :id="goalTitleId" class="nadia-chat-bold text-pretty text-ink">
                    {{ label ? t("developmentJourneys.goalCard.titleWithLabel", { title: goal.title, label }) : goal.title }}
                </h2>
                <p class="body-small text-ink-muted">{{ goal.achievement_criteria }}</p>
                <I18nT v-if="goal.target_date" keypath="developmentJourneys.goalCard.due" tag="p" class="scaffold-details-small mt-1 text-ink-muted">
                    <template #date>
                        <template v-if="previousTargetDate">
                            <del data-testid="development-goal-previous-target-date"><BaseDate :value="previousTargetDate" format="date-long" /></del>
                            <i class="bi bi-arrow-right mx-2 text-xs" aria-hidden="true"></i>
                        </template>
                        <BaseDate :value="goal.target_date" format="date-long" />
                    </template>
                </I18nT>
            </div>
        </BaseCard>
    </section>
</template>

<script setup lang="ts">
import BaseCard from "~vue/components/BaseCard.vue";
import BaseDate from "~vue/components/BaseDate.vue";
import DevelopmentGoalHourglass from "~vue/icons/DevelopmentJourneyHourglass.vue";
import type { DevelopmentGoalDraft } from "~vue/types/chat";
import { useId } from "vue";
import { I18nT, useI18n } from "vue-i18n";

defineProps<{ goal: DevelopmentGoalDraft; label?: string; previousTargetDate?: string | null }>();
const goalTitleId = useId();
const { t } = useI18n();
</script>

<style scoped>
@reference "../../../css/tailwind.css";

@layer components {
    /* Same neutral icon tile as the other chat cards (learning resource, documents). */
    .icon {
        @apply flex size-9 shrink-0 items-center justify-center rounded-lg bg-surface-sunken;
    }
}
</style>
